import script from "./SelectArtistUserAccountId.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectArtistUserAccountId.vue?vue&type=script&setup=true&lang=js"

import "./SelectArtistUserAccountId.vue?vue&type=style&index=0&id=61d539be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61d539be"]])

export default __exports__